<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<{
    class?: HTMLAttributes["class"];
}>();
</script>

<template>
    <th
        :class="
            cn(
                'h-12 px-4 font-medium text-iron-700 dark:text-stone-400 [&:has([role=checkbox])]:pr-0 text-left align-middle',
                props.class,
            )
        "
    >
        <slot />
    </th>
</template>
